export const DEFAULT_STATE = null;

export default function (state = DEFAULT_STATE, action) {
    switch (action.type) {
        case 'EventOccurrenceVenueActions.ON_BEFORE_GET':
            return DEFAULT_STATE;

        case 'EventOccurrenceVenueActions.ON_GET':
            return action.result;

        default:
            return state;
    }
}
